module.exports = __webpack_public_path__ + "static/media/sree.82b0db25.png";